// Pembuat pilihan jawaban: 4 opsi unik dengan pengecoh yang masuk akal.
import { F, FM, fmt } from '../../core/format.js';
import { r3, simp } from '../../core/math.js';
import { R, coin, shuffle } from '../../core/random.js';

// Pilih 3 pengecoh supaya jawaban benar jatuh di posisi acak (A–D) setelah pilihan diurutkan.
// `utama` = pengecoh yang sengaja dibuat (kesalahan umum), `cadangan` = nilai di sekitar jawaban.
function pilihPengecoh(c, utama, cadangan, nilai) {
  const v = x => nilai(x), vc = nilai(c);
  const bawah = [...shuffle(utama.filter(x => v(x) < vc)), ...cadangan.filter(x => v(x) < vc).sort((a, b) => v(b) - v(a))];
  const atas = [...shuffle(utama.filter(x => v(x) > vc)), ...cadangan.filter(x => v(x) > vc).sort((a, b) => v(a) - v(b))];
  const posisi = [0, 1, 2, 3].filter(t => bawah.length >= t && atas.length >= 3 - t);
  const t = posisi.length ? posisi[R(0, posisi.length - 1)] : Math.min(3, bawah.length);
  const out = [...bawah.slice(0, t), c, ...atas.slice(0, 3 - t)];
  for (const x of [...bawah.slice(t), ...atas.slice(3 - t)]) if (out.length < 4) out.push(x);
  return out.sort((a, b) => v(a) - v(b));
}

export function optNum(c,ds,f,step){
  c=r3(c);f=f||fmt;step=step||Math.max(1,Math.round(Math.abs(c)/10));
  const seen=[c];
  const ok=v=>{v=r3(v);if(!(v>0)||!isFinite(v)||seen.some(o=>Math.abs(o-v)<1e-9))return null;seen.push(v);return v;};
  const utama=ds.map(ok).filter(v=>v!=null);
  const cadangan=[];for(let g=1;g<=6;g++)for(const v of [c-g*step,c+g*step]){const x=ok(v);if(x!=null)cadangan.push(x);}
  const out=pilihPengecoh(c,utama,cadangan,x=>x);
  return {type:'pg',options:out.map(f),answer:out.findIndex(v=>Math.abs(v-c)<1e-9)};
}
export function optFrac(c,ds,raw){
  const key=p=>simp(p[0],p[1]).join('/');
  const keys=new Set([key(c)]);
  const ok=p=>{const [n,d]=p;if(!(n>0&&d>0)||!Number.isInteger(n)||!Number.isInteger(d))return false;if(raw&&n>=d)return false;const k=key(p);if(keys.has(k))return false;keys.add(k);return true;};
  const utama=ds.filter(ok);
  const [n,d]=c,cadangan=[];
  for(let g=1;g<=4;g++)for(const p of [[n-g,d],[n+g,d],[n*2-g,d*2],[n*2+g,d*2]])if(ok(p))cadangan.push(p);
  const out=pilihPengecoh(c,utama,cadangan,p=>p[0]/p[1]);
  return {type:'pg',options:out.map(p=>raw?F(p[0],p[1]):FM(p[0],p[1])),answer:out.findIndex(p=>key(p)===key(c))};
}
export function optText(c,ds,pool){
  const out=[c];ds.forEach(d=>{if(out.length<4&&!out.includes(d))out.push(d);});
  if(pool)shuffle(pool).forEach(d=>{if(out.length<4&&!out.includes(d))out.push(d);});
  const o=shuffle(out);return {type:'pg',options:o,answer:o.indexOf(c)};
}
